// Single source of truth for gating unreleased features.
//
// VIDEO_RECORDER_ENABLED — controls the entire gift-recorder + gift-message
// feature set. Until product / legal approval to ship, this MUST stay `false`.
// Flipping it to `true` is the only change required to expose the feature
// across the whole app.
//
// When `false`:
//   • Sender self-record prompt + slot-based recorder (gift-flow step 1) — hidden
//   • Navigation never lands on step1SubStep 3 (prompt) or 4 (recorder)
//   • Contributor "Record Yourself & Send" tile (gift-flow step 3 upload) — hidden
//   • Contributor occasion picker + recorder modal — hidden
//   • Receiver-side "Record yourself" Yes/No prompt screen (gift-content) — skipped
//   • Receiver-side recorder + occasion picker (gift-content) — hidden
//   • GiftMessagePlayer popup (the "play your gift" overlay on gift-content) — hidden
//   • Per-folder "🎁 Open Gift" pills on gift-content folder cards — hidden
//   • Phone-as-webcam (/mobile-camera/:sessionId) — renders an unavailable view
//
// When `true`: everything above is restored to its normal behaviour.
//
// Do NOT add additional conditions for hiding the feature in other places
// without also gating them on this flag — the goal is one switch to rule
// them all so re-enabling is a one-line change.
export const VIDEO_RECORDER_ENABLED = true;
export const VIDEO_RECORDER_COMMENTARY_ENABLED = false;

// GIFT_PLAN_CARDS_MOBILE_VERTICAL — controls how the gift plan cards are laid
// out on mobile (≤900px) in the payment step.
//   • true  → cards stack vertically, one below the other (no swipe carousel)
//   • false → original horizontal swipe carousel with dots
// Desktop is unaffected either way. Flip this one line to switch layouts.
export const GIFT_PLAN_CARDS_MOBILE_VERTICAL = true;
